import { formatCurrency } from '@shared/utils/currency';
import {
	CargoUnitSingularLabels,
	FreightRateType,
} from '@shared/utils/constants';
import type { CargoProps } from '@api/models/cargo';

export const formatFreightRate = (
	rate: number,
	cargo: Pick<CargoProps, 'currency' | 'freightType' | 'unit'>,
) => {
	const formattedRate = formatCurrency(rate, cargo.currency);

	if (cargo.freightType !== FreightRateType.PER_UNIT) {
		return formattedRate;
	}

	return `${formattedRate} / ${CargoUnitSingularLabels[cargo.unit]}`;
};
